import { Bound } from "lib/@components/binding/Bound"
import { useAuthoringRecommendationSummary } from "./hooks/use-authoring-recommendation-summary"

export function AuthoringRecommendationSummaryBound({ children }) {
    const { summary, refetchRecommendations, recommendationsLoading } = useAuthoringRecommendationSummary()

    return (
        <Bound
            authoringRecommendationSummary={summary}
            refetchAuthoringRecommendations={refetchRecommendations}
            authoringRecommendationsLoading={recommendationsLoading}
        >
            {children}
        </Bound>
    )
}
